/**
 * Brands strip — pause all rows on hover, handle reduced-motion.
 */
(function () {
    'use strict';

    var strip = document.querySelector('.brands-strip');
    if (!strip) return;

    var tracks = strip.querySelectorAll('.brands-strip__track');
    if (!tracks.length) return;

    function setState(state) {
        tracks.forEach(function (track) {
            track.style.animationPlayState = state;
        });
    }

    strip.addEventListener('mouseenter', function () { setState('paused'); });
    strip.addEventListener('mouseleave', function () { setState('running'); });

    // Touch: tap toggles pause
    var paused = false;
    strip.addEventListener('touchstart', function () {
        paused = !paused;
        setState(paused ? 'paused' : 'running');
    }, { passive: true });
})();
